import { render, staticRenderFns } from "./GroupLoadingView.vue?vue&type=template&id=8d59634a&scoped=true&"
import script from "./GroupLoadingView.vue?vue&type=script&lang=js&"
export * from "./GroupLoadingView.vue?vue&type=script&lang=js&"
import style0 from "./GroupLoadingView.vue?vue&type=style&index=0&id=8d59634a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d59634a",
  null
  
)

export default component.exports